import { useCallback, useEffect, useState } from 'react'

import moment from 'moment'

import { menuActivePeriodsFetcher } from '@library/menu-service'

type ActivePeriod = {
  id: string
  period_id: string
  from: string
  until: string
}

type ActivePeriodsResponse = {
  data: ActivePeriod[]
}

// A slot belongs to the menu whose ordering window contains its `whenCutoff`.
const findPeriodIdForCutoff = (cutoff: string, periods: ActivePeriod[]): string | undefined => {
  const target = moment(cutoff)
  const match = periods.find((period) =>
    target.isBetween(moment(period.from), moment(period.until), undefined, '[]'),
  )

  return match?.period_id
}

export type UseCurrentMenuPeriod = {
  getPeriodIdForCutoff: (cutoff: string | undefined) => string | undefined
}

export const useCurrentMenuPeriod = (): UseCurrentMenuPeriod => {
  const [periods, setPeriods] = useState<ActivePeriod[] | null>(null)

  useEffect(() => {
    let cancelled = false

    ;(menuActivePeriodsFetcher() as Promise<ActivePeriodsResponse>)
      .then((response) => {
        if (!cancelled) setPeriods(response.data)
      })
      .catch(() => {
        // Fail open — consumer treats undefined as "menu will change".
      })

    return () => {
      cancelled = true
    }
  }, [])

  const getPeriodIdForCutoff = useCallback(
    (cutoff: string | undefined) => {
      if (!periods) return undefined
      if (!cutoff) return undefined

      return findPeriodIdForCutoff(cutoff, periods)
    },
    [periods],
  )

  return { getPeriodIdForCutoff }
}
